/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file

  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'

// Sidebar Scroll : https://stackoverflow.com/questions/56105413/how-to-scroll-an-overlay-sidebar-only-without-scrolling-the-whole-page
import VueScrollStop from 'vue-scroll-stop'
Vue.use(VueScrollStop)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// app context
const ctx = {}

// axios
import axios from './axios.js'
Vue.prototype.$http = axios
ctx.axios = axios



// lazy load
import VueLazyload from 'vue-lazyload'

// or with options
// const loadimage = require('./assets/loading.gif')
// const errorimage = require('./assets/error.gif')
// Vue.use(VueLazyload)

Vue.use(VueLazyload, {
  // preLoad: 1.3,
  // error: errorimage,
  // loading: loadimage,
  // attempt: 1
})

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

// API Calls
import './http/requests'

// mock
// import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'

// Firebase
import '@/firebase/firebase'


// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)

// ACL
import acl from './acl/acl'
ctx.acl = acl

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'
ctx.router = router

// Vuex Store
import store from './store/store'
ctx.store = store(ctx)

// i18n
import i18n from './i18n/i18n'
ctx.i18n = i18n

// Vuexy Admin Filters
import './filters/filters'

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// Google Maps
// import * as VueGoogleMaps from 'vue2-google-maps'
// Vue.use(VueGoogleMaps, {
//   load: {
//     // Add your API key here
//     key: 'AIzaSyB4DDathvvwuwlwnUu7F4Sow3oU22y5T1Y',
//     libraries: 'places' // This is required if you use the Auto complete plug-in
//   }
// })

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// Google Analytics
import VueAnalytics from 'vue-analytics'

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-154226615-3',
    router: ctx.router
  })
}

// Airbrake
import { Notifier } from '@airbrake/browser'
import * as Sentry from "@sentry/vue";

if (process.env.NODE_ENV === 'production') {
  ctx.airbrake = new Notifier({
    environment: 'production',
    projectId: 275171,
    projectKey: '60e169f3e70583fa5d5745f3bebd9739'
  })

  Vue.config.errorHandler = function (err, vm, info) {
    ctx.airbrake.notify({
      error: err,
      context: { userId: 1 },
      params: { userId: 2 }
      // params: { info }
    })
  }

  Sentry.init({
    Vue,
    dsn: "https://818de399a7fe4534ae99017cb0031ddf@o4505000022638592.ingest.sentry.io/4505000023818240",
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ["improvee.io", "https://self-improvee-stage.herokuapp.com", /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });

}

// Directives ------------------------------------------

Vue.directive('visible', function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden'
})

// Vue Force Next Tick
import VueForceNextTick from 'vue-force-next-tick'
Vue.use(VueForceNextTick)

// Init Vue
Vue.config.productionTip = false

new Vue({
  router: ctx.router,
  store: ctx.store,
  i18n: ctx.i18n,
  // acl: ctx.acl,
  render: h => h(App)
}).$mount('#app')


const development = process.env.NODE_ENV === 'development'

Vue.prototype.$environment = process.env.NODE_ENV
Vue.prototype.$development = development
Vue.prototype.$production = !development

Vue.mixin({
  methods: {
    isDevEnv: () => development
  },
})

Vue.mixin({
  data () {
    return {
      actionElementCss: { 'hover:text-warning': true, 'cursor-pointer': true }
    }
  },
})

import ContextNotifier from '@/services/ContextNotifications'
Vue.mixin({
  computed: {
    notifier () { return new ContextNotifier(this.$vs.notify, this.$store.getters.isMobile) },
  },
})

// vuex fire --------------------------
import { firestoreOptions } from 'vuexfire'

// always wait for bindings to be resolved
firestoreOptions.wait = true
